import { useQuery } from '@tanstack/react-query';
import type { FlowState, Workflow, WorkflowVersion } from '~/flow/types';
import apiCalls from '~/helpers/apiCalls';
import type { ResponseException } from '~/helpers/exceptionHandler';

type UseWorkflowDataOptions = {
  // @ts-ignore
  workflowToken: Workflow['application_token'];
  versionId: WorkflowVersion['application_version_id'];
  // Controls whether the workflow data query should automatically execute
  enabled?: boolean;
};

function getQueryKey({ versionId, workflowToken }: UseWorkflowDataOptions) {
  return ['workflow.data', workflowToken, versionId];
}

function useWorkflowData(options: UseWorkflowDataOptions) {
  const { versionId: publicVersion, workflowToken: applicationToken, enabled = true } = options;
  return useQuery<FlowState, ResponseException>({
    queryKey: getQueryKey(options),
    queryFn: () => apiCalls.workflows.getWorkflowVersion({ applicationToken, publicVersion }),
    retry: false,
    refetchOnReconnect: false,
    enabled,
  });
}

useWorkflowData.getQueryKey = getQueryKey;
export default useWorkflowData;
